import React, { useEffect, useState } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import {
    Box,
    Radio,
    RadioGroup,
    FormControl,
    FormControlLabel,
    FormLabel,
    TextField,
    Button,
    Typography,
    Paper,
} from "@mui/material";
import Select from "react-select";
import {
    useGetAllUserMutation,
    useSendNotificationMutation,
} from "slices/staffSlice";

const SELECT_ALL_OPTION = {
    value: "ALL",
    label: "Select All",
};

const Notification = () => {
    const [type, setType] = useState("");
    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [selectedUsers, setSelectedUsers] = useState([]);

    const [getUserData, { data: Users }] = useGetAllUserMutation();
    const [sendNotify, { data: Notify }] = useSendNotificationMutation();

    /* Fetch users when type changes */
    useEffect(() => {
        if (type) {
            getUserData({ type });
            setSelectedUsers([]); // reset selection
        }
    }, [type]);

    /* Success response */
    useEffect(() => {
        if (Notify?.success) {
            alert(Notify.message);
            setType("");
            setTitle("");
            setDescription("");
            setSelectedUsers([]);
        }
    }, [Notify]);

    /* Convert API users to react-select options */
    const userOptions =
        Users?.data?.map((user) => ({
            value: user._id,
            label: user.name || user.email || "Unnamed User",
        })) || [];

    const optionsWithSelectAll = [SELECT_ALL_OPTION, ...userOptions];

    /* Handle select change */
    const handleUserSelect = (selected) => {
        if (selected?.some((opt) => opt.value === "ALL")) {
            setSelectedUsers(userOptions);
        } else {
            setSelectedUsers(selected || []);
        }
    };

    /* Submit */
    const handleSubmitData = () => {
        if (!type || !title || !description) {
            alert("Please fill all fields");
            return;
        }

        if (selectedUsers.length === 0) {
            alert("Please select at least one user");
            return;
        }

        sendNotify({
            type,
            title,
            description,
            userIds: selectedUsers.map((u) => u.value),
        });
    };

    return (
        <DashboardLayout>
            <DashboardNavbar />

            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                    mt: 5,
                }}
            >
                <Paper
                    elevation={4}
                    sx={{
                        width: "100%",
                        maxWidth: 1000,
                        p: 4,
                        borderRadius: 3,
                    }}
                >
                    <Typography variant="h5" sx={{ mb: 3, fontWeight: 600 }}>
                        Send Notification
                    </Typography>

                    {/* Type Selection */}
                    <FormControl sx={{ mb: 3 }}>
                        <FormLabel>Select Type</FormLabel>
                        <RadioGroup
                            row
                            value={type}
                            onChange={(e) => setType(e.target.value)}
                        >
                            <FormControlLabel value="user" control={<Radio />} label="User" />
                            <FormControlLabel
                                value="doctor"
                                control={<Radio />}
                                label="Doctor"
                            />
                            <FormControlLabel
                                value="guest"
                                control={<Radio />}
                                label="Guest"
                            />
                            <FormControlLabel
                                value="beautician"
                                control={<Radio />}
                                label="Beautician"
                            />
                            <FormControlLabel
                                value="clinic"
                                control={<Radio />}
                                label="Clinic"
                            />
                        </RadioGroup>
                    </FormControl>

                    {/* User Select */}
                    {type && (
                        <Box sx={{ mb: 3 }}>
                            <Typography variant="h6" sx={{ mb: 1 }}>
                                Select {Users?.data?.length > 0 ? `${type} (${Users.data.length})` : `Count (0)`}
                            </Typography>

                            <Select
                                isMulti
                                options={optionsWithSelectAll}
                                value={selectedUsers}
                                onChange={handleUserSelect}
                                placeholder={`Select ${type}s...`}
                                closeMenuOnSelect={false}
                            />

                            {selectedUsers.length > 0 && (
                                <Typography sx={{ mt: 1 }} variant="body2">
                                    Selected: {selectedUsers.length}
                                </Typography>
                            )}
                        </Box>
                    )}

                    {/* Title */}
                    <TextField
                        label="Title"
                        fullWidth
                        sx={{ mb: 3 }}
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                    />

                    {/* Description */}
                    <TextField
                        label="Description"
                        multiline
                        rows={4}
                        fullWidth
                        sx={{ mb: 3 }}
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                    />

                    <Button variant="contained" fullWidth onClick={handleSubmitData}>
                        Send Notification
                    </Button>
                </Paper>
            </Box>
        </DashboardLayout>
    );
};

export default Notification;
